module.exports = __webpack_public_path__ + "img/抄表系统运行数据看板.33341005.png";